export default __webpack_public_path__ + "static/project-slide-4-1640-765-3e37d7719b70698dcaefda0f927aa6b2.webp";